/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { PureComponent } from 'react';
import FormField from '../helpers/FormField';
import { TextInput } from '../../../uiold';
import { validateInput, validateRealTime } from './validators';

import { FormFieldDefinition } from '../../../../types/shared/FormFieldDefinition';

type Props = {
  definition: FormFieldDefinition;
  readOnly?: boolean;
  onChange?: (id: string, value: string) => void;
  onValidityChange?: (
    id: string,
    validationError: string | null | undefined,
  ) => void;
};

type State = {
  inputValue: string;
};

class TextInputElementFormView extends PureComponent<Props, State> {
  state: State = {
    inputValue: '',
  };

  render() {
    let { props } = this;
    return <FormField {...props}>{this._renderField()}</FormField>;
  }

  _renderField = () => {
    let { definition, readOnly } = this.props;
    // TODO: Better solution here.
    if (definition.type !== 'TextElement') {
      return null;
    }
    let { inputValue } = this.state;
    let multi = definition.multiline
      ? {
          multiline: true,
          numberOfLines: 3,
        }
      : {};
    return (
      <TextInput
        {...multi}
        testID={`form-text-input-${definition.id}`}
        tabIndex={readOnly ? -1 : undefined}
        placeholder={definition.placeholder || ''}
        value={inputValue}
        onChangeText={this._onInputChange}
        onBlur={this._onInputBlur}
      />
    );
  };

  _onInputBlur = (event: any) => {
    let { value } = event.target;
    let { definition, onChange, onValidityChange } = this.props;
    if (definition.type === 'TextElement') {
      if (onChange != null) {
        onChange(definition.id, value);
      }
      if (onValidityChange) {
        let validationError = validateInput(definition.field_validation, value);
        onValidityChange(definition.id, validationError);
      }
    }
  };

  _onInputChange = (value: string) => {
    let { definition, onValidityChange } = this.props;
    if (definition.type === 'TextElement') {
      value = validateRealTime(definition.field_validation, value);
    }
    // Disabled until we can make render faster for large forms. With this
    // turned on, every keystroke will cause the a state change in FormEmbed,
    // causing a re-render. That should be fine except it's taking over 300ms
    // to render in some cases.
    // if (onChange != null) {
    //   onChange(definition.id, value);
    // }
    if (onValidityChange != null) {
      onValidityChange(definition.id, null);
    }
    this.setState({ inputValue: value });
  };

  setValue(value: unknown) {
    this.setState({ inputValue: String(value) });
  }

  getValue() {
    return this.state.inputValue;
  }
}

export default TextInputElementFormView;
